"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importDefault(require("react"));
var VipWheelOfFortune_1 = __importDefault(require("./VipWheelOfFortune"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var VipWheelModal = function () {
    return (react_1.default.createElement(ui_components_1.Modal, { width: "revert-layer", padding: "0", id: "wheel", className: styles_module_scss_1.default.container, closeIconClassName: styles_module_scss_1.default.closeIcon },
        react_1.default.createElement(VipWheelOfFortune_1.default, null)));
};
exports.default = VipWheelModal;
